import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RecordReceptionParams } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const recordReception = createAsyncThunk<
  void,
  RecordReceptionParams,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.RECORD_RECEPTION, async (params, { extra }) => {
  await extra.batchesRepo.recordReception(params);
});
